export default [
  {
    path: "/invite-users",
    name: "users-subscribed",
    component: () =>
      import("@/views/admin/invite/InviteUsers.vue"),
  },
];
